import { jsx as u, Fragment as g } from "react/jsx-runtime";
import * as s from "react";
import "react-dom";
function y(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function w(...e) {
  return (n) => {
    let t = !1;
    const l = e.map((o) => {
      const r = y(o, n);
      return !t && typeof r == "function" && (t = !0), r;
    });
    if (t)
      return () => {
        for (let o = 0; o < l.length; o++) {
          const r = l[o];
          typeof r == "function" ? r() : y(e[o], null);
        }
      };
  };
}
var v = s.forwardRef((e, n) => {
  const { children: t, ...l } = e, o = s.Children.toArray(t), r = o.find(N);
  if (r) {
    const i = r.props.children, a = o.map((m) => m === r ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : m);
    return /* @__PURE__ */ u(d, { ...l, ref: n, children: s.isValidElement(i) ? s.cloneElement(i, void 0, a) : null });
  }
  return /* @__PURE__ */ u(d, { ...l, ref: n, children: t });
});
v.displayName = "Slot";
var d = s.forwardRef((e, n) => {
  const { children: t, ...l } = e;
  if (s.isValidElement(t)) {
    const o = S(t), r = R(l, t.props);
    return t.type !== s.Fragment && (r.ref = n ? w(n, o) : o), s.cloneElement(t, r);
  }
  return s.Children.count(t) > 1 ? s.Children.only(null) : null;
});
d.displayName = "SlotClone";
var C = ({ children: e }) => /* @__PURE__ */ u(g, { children: e });
function N(e) {
  return s.isValidElement(e) && e.type === C;
}
function R(e, n) {
  const t = { ...n };
  for (const l in n) {
    const o = e[l], r = n[l];
    /^on[A-Z]/.test(l) ? o && r ? t[l] = (...a) => {
      r(...a), o(...a);
    } : o && (t[l] = o) : l === "style" ? t[l] = { ...o, ...r } : l === "className" && (t[l] = [o, r].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function S(e) {
  var l, o;
  let n = (l = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : l.get, t = n && "isReactWarning" in n && n.isReactWarning;
  return t ? e.ref : (n = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, t = n && "isReactWarning" in n && n.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var E = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], j = E.reduce((e, n) => {
  const t = s.forwardRef((l, o) => {
    const { asChild: r, ...i } = l, a = r ? v : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u(a, { ...i, ref: o });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {}), P = "Label", h = s.forwardRef((e, n) => /* @__PURE__ */ u(
  j.label,
  {
    ...e,
    ref: n,
    onMouseDown: (t) => {
      var o;
      t.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
    }
  }
));
h.displayName = P;
var _ = h;
function O(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var f = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var b;
function x() {
  return b || (b = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var a = arguments[i];
          a && (r = o(r, l(a)));
        }
        return r;
      }
      function l(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var a in r)
          n.call(r, a) && r[a] && (i = o(i, a));
        return i;
      }
      function o(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(f)), f.exports;
}
var D = x();
const V = /* @__PURE__ */ O(D), c = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, p = "purpur-label", M = ({
  children: e,
  className: n,
  disabled: t,
  negative: l = !1,
  ...o
}) => {
  const r = V([
    n,
    c[p],
    {
      [c[`${p}--disabled`]]: t,
      [c[`${p}--negative`]]: l
    }
  ]);
  return /* @__PURE__ */ u(_, { className: r, ...o, children: e });
};
export {
  M as Label
};
//# sourceMappingURL=label.es.js.map
